import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const LocationIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Location`} {...props}>
    <Path
      fill="#001A19"
      d="M7.978.25a6.478 6.478 0 0 1 6.476 6.478c0 2.528-1.607 4.779-3.068 6.322a20.112 20.112 0 0 1-2.917 2.522l-.054.037-.015.01-.004.003-.002.002a.75.75 0 0 1-.832 0L7.978 15l-.417.624v-.001h-.002l-.004-.004c-.004-.002-.01-.005-.016-.01l-.053-.037c-.045-.031-.112-.077-.194-.136a20.122 20.122 0 0 1-2.723-2.386C3.108 11.507 1.5 9.256 1.5 6.728A6.477 6.477 0 0 1 7.978.25Zm0 1.5A4.978 4.978 0 0 0 3 6.728c0 1.925 1.256 3.81 2.658 5.29a18.623 18.623 0 0 0 2.319 2.058 18.618 18.618 0 0 0 2.32-2.058c1.402-1.48 2.657-3.365 2.657-5.29A4.978 4.978 0 0 0 7.978 1.75Zm0 2.318a2.66 2.66 0 1 1-.001 5.32 2.66 2.66 0 0 1 0-5.32Zm0 1.5a1.16 1.16 0 1 0 0 2.319 1.16 1.16 0 0 0 0-2.319Z"
    />
  </Icon>
);
